var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWithdrawLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/withdraw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0.875L14.4062 4.48428H13.2031V6.89047H10.7969V4.48428H9.59381L12 0.875ZM20.4217 9.29666V18.9214H3.57834V9.29666H20.4217ZM21.6248 8.09357H2.37524V20.1245H21.6248V8.09357Z",
    fill: "#D66700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 10.5C12.474 10.5 12.9433 10.5934 13.3812 10.7747C13.8191 10.9561 14.217 11.222 14.5521 11.5571C14.8873 11.8923 15.1532 12.2902 15.3345 12.7281C15.5159 13.166 15.6093 13.6353 15.6093 14.1093C15.6093 14.5833 15.5159 15.0526 15.3345 15.4905C15.1532 15.9284 14.8873 16.3263 14.5521 16.6614C14.217 16.9966 13.8191 17.2624 13.3812 17.4438C12.9433 17.6252 12.474 17.7186 12 17.7186H18.0155V16.5155H19.2186V11.7031H18.0155V10.5H12ZM8.39072 14.1093C8.39072 13.152 8.77098 12.234 9.44785 11.5571C10.1247 10.8803 11.0428 10.5 12 10.5H5.98453V11.7031H4.78143V16.5155H5.98453V17.7186H12C11.0428 17.7186 10.1247 17.3383 9.44785 16.6614C8.77098 15.9846 8.39072 15.0665 8.39072 14.1093Z",
    fill: "#D66700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdrawLight);
export default __webpack_public_path__ + "static/media/icon_withdraw_light.6d403ae89f366ea2e6eba7c521b519e9.svg";
export { ForwardRef as ReactComponent };